import { v4 as uuidv4 } from 'uuid'

/**
 * Return random generated UUID
 */
const getRandomUUID = () => {
  return uuidv4()
}

export default getRandomUUID
